export default "__VITE_ASSET__C6ftB5m7__"